module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/2LOZN9mZtC20yysmiYkAgG-fd05cb503da27d2aab4ba8dd2069671e.jpg";